module.exports = __webpack_public_path__ + "static/img/5.ba8a9dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/5.jpg
// module id = rrR6
// module chunks = 6